import { createAction, createReducer, ThunkMiddleware } from '@reduxjs/toolkit';

import { signInSuccess } from '@app/store/account/local/actions';
import { FORM_RECOMMENDATION_TOGGLE_DISPLAY } from '@app/store/actionTypes';
import { RootState } from '@app/store/types';

export const FORM_RECOMMENDATION_LOCAL_STORAGE_KEY = 'isFormRecommendationSheetOpen';

interface FormRecommendationState {
  isMinimized: boolean;
}

const initialState: FormRecommendationState = {
  isMinimized: false,
};

export const toggleDisplay = createAction<
  {
    isMinimized: boolean;
  },
  typeof FORM_RECOMMENDATION_TOGGLE_DISPLAY
>(FORM_RECOMMENDATION_TOGGLE_DISPLAY);

export const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(signInSuccess, (_state, _action) => {
      return initialState;
    })
    .addCase(toggleDisplay, (state, action) => {
      state.isMinimized = action.payload.isMinimized;
    });
});

export const formRecommendationMiddleware: ThunkMiddleware = (_store) => (next) => (action) => {
  if (signInSuccess.match(action)) {
    localStorage.setItem(FORM_RECOMMENDATION_LOCAL_STORAGE_KEY, 'true');
  }
  return next(action);
};

export const getIsMinimized = (state: RootState) => state.formRecommendation.isMinimized;
